import { render, staticRenderFns } from "./DetalleProducto.vue?vue&type=template&id=78bc7d2c&scoped=true"
import script from "./DetalleProducto.vue?vue&type=script&lang=js"
export * from "./DetalleProducto.vue?vue&type=script&lang=js"
import style0 from "./DetalleProducto.vue?vue&type=style&index=0&id=78bc7d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc7d2c",
  null
  
)

export default component.exports